// // assets/cart-drawer.js

// // Placeholder for CartItems class (assumed to be defined elsewhere, e.g., global.js)
// // If not defined, this minimal version prevents errors

// class CartItems extends HTMLElement {
//   constructor() {
//     super();
//   }
// }

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".cart-drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }

//   // class CartDrawer extends HTMLElement {
//   //   constructor() {
//   //     super();
//   //     this.addEventListener(
//   //       "keyup",
//   //       (evt) => evt.code === "Escape" && this.close()
//   //     );
//   //     this.querySelector("#CartDrawer-Overlay").addEventListener(
//   //       "click",
//   //       this.close.bind(this)
//   //     );
//   //     this.setHeaderCartIconAccessibility();
//   //   }

//   //   setHeaderCartIconAccessibility() {
//   //     const cartLink = document.querySelector("#cart-icon-bubble");
//   //     if (!cartLink) {
//   //       console.error("Cart icon (#cart-icon-bubble) not found");
//   //       return;
//   //     }
//   //     console.log("Attaching event listeners to cart icon");
//   //     cartLink.setAttribute("role", "button");
//   //     cartLink.setAttribute("aria-haspopup", "dialog");
//   //     cartLink.addEventListener("click", (event) => {
//   //       event.preventDefault();
//   //       console.log("Cart icon clicked, opening drawer");
//   //       this.open(cartLink);
//   //     });
//   //     cartLink.addEventListener("keydown", (event) => {
//   //       if (event.code.toUpperCase() === "SPACE") {
//   //         event.preventDefault();
//   //         this.open(cartLink);
//   //       }
//   //     });
//   //   }

//   //   open(triggeredBy) {
//   //     if (triggeredBy) this.setActiveElement(triggeredBy);
//   //     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//   //     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
//   //       this.setSummaryAccessibility(cartDrawerNote);
//   //     setTimeout(() => {
//   //       this.classList.add("animate", "active");
//   //     });
//   //     this.addEventListener(
//   //       "transitionend",
//   //       () => {
//   //         const containerToTrapFocusOn = this.classList.contains("is-empty")
//   //           ? this.querySelector(".drawer__inner-empty")
//   //           : document.getElementById("CartDrawer");
//   //         const focusElement =
//   //           this.querySelector(".drawer__inner") ||
//   //           this.querySelector(".drawer__close");
//   //         trapFocus(containerToTrapFocusOn, focusElement);
//   //       },
//   //       { once: true }
//   //     );
//   //     document.body.classList.add("overflow-hidden");
//   //   }

//   //   close() {
//   //     this.classList.remove("active");
//   //     removeTrapFocus(this.activeElement);
//   //     document.body.classList.remove("overflow-hidden");
//   //   }

//   //   setSummaryAccessibility(cartDrawerNote) {
//   //     cartDrawerNote.setAttribute("role", "button");
//   //     cartDrawerNote.setAttribute("aria-expanded", "false");
//   //     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//   //       cartDrawerNote.setAttribute(
//   //         "aria-controls",
//   //         cartDrawerNote.nextElementSibling.id
//   //       );
//   //     }
//   //     cartDrawerNote.addEventListener("click", (event) => {
//   //       event.currentTarget.setAttribute(
//   //         "aria-expanded",
//   //         !event.currentTarget.closest("details").hasAttribute("open")
//   //       );
//   //     });
//   //     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   //   }

//   //   renderContents(parsedState) {
//   //     this.querySelector(".drawer__inner").classList.contains("is-empty") &&
//   //       this.querySelector(".drawer__inner").classList.remove("is-empty");
//   //     this.productId = parsedState.id;
//   //     this.getSectionsToRender().forEach((section) => {
//   //       const sectionElement = section.selector
//   //         ? document.querySelector(section.selector)
//   //         : document.getElementById(section.id);
//   //       if (!sectionElement) return;
//   //       sectionElement.innerHTML = this.getSectionInnerHTML(
//   //         parsedState.sections[section.id],
//   //         section.selector
//   //       );
//   //     });
//   //     setTimeout(() => {
//   //       this.querySelector("#CartDrawer-Overlay").addEventListener(
//   //         "click",
//   //         this.close.bind(this)
//   //       );
//   //       this.open();
//   //     });
//   //   }

//   //   getSectionInnerHTML(html, selector = ".shopify-section") {
//   //     return new DOMParser()
//   //       .parseFromString(html, "text/html")
//   //       .querySelector(selector).innerHTML;
//   //   }

//   //   getSectionsToRender() {
//   //     return [
//   //       { id: "cart-drawer", selector: "#CartDrawer" },
//   //       { id: "cart-icon-bubble" },
//   //     ];
//   //   }

//   //   getSectionDOM(html, selector = ".shopify-section") {
//   //     return new DOMParser()
//   //       .parseFromString(html, "text/html")
//   //       .querySelector(selector);
//   //   }

//   //   setActiveElement(element) {
//   //     this.activeElement = element;
//   //   }
//   // }

//   renderContents(parsedState) {
//     // Update cart items list
//     this.classList.toggle("is-empty", parsedState.items.length === 0);
//     if (parsedState.sections && parsedState.sections["cart-drawer"]) {
//       const cartItemsList = this.querySelector(".cart-items");
//       if (cartItemsList) {
//         cartItemsList.innerHTML = new DOMParser()
//           .parseFromString(parsedState.sections["cart-drawer"], "text/html")
//           .querySelector(".cart-items").innerHTML;
//         cartItemsList.classList.toggle(
//           "is-empty",
//           parsedState.items.length === 0,
//         );
//       }
//     }
//   }
// }

// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();
//     this.bindEvents();
//   }

//   bindEvents() {
//     // Escape key to close drawer
//     this.addEventListener("keyup", (evt) => {
//       if (evt.code === "Escape") {
//         this.close();
//       }
//     });

//     // Overlay click to close drawer
//     const overlay = this.querySelector("#CartDrawer-Overlay");
//     if (overlay) {
//       overlay.addEventListener("click", this.close.bind(this));
//     }

//     // Close button
//     const closeButton = this.querySelector(".drawer__close");
//     if (closeButton) {
//       closeButton.addEventListener("click", this.close.bind(this));
//     }

//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     const shouldBlockDrawer = () => {
//       const path = window.location.pathname;
//       return (
//         path === "/cart" ||
//         path === /^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/cart$/.test(path)
//       );
//     };
//     cartLink.addEventListener("click", (event) => {
//       if (shouldBlockDrawer()) {
//         return;
//       }
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener("keydown", (event) => {
//       if (shouldBlockDrawer()) {
//         return;
//       }
//       if (event.code.toUpperCase() === "SPACE") {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   shouldBlockDrawer() {
//     const path = window.location.pathname;
//     return (
//       path === "/cart" ||
//       path === /^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/cart$/.test(path)
//     );
//   }
//   open(triggeredBy) {
//     if (this.shouldBlockDrawer()) {
//       return;
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }
//     this.classList.add("animate", "active");
//     this.style.display = "block";
//     this.style.visibility = "visible";

//     const cartDrawerInner = this.querySelector("#CartDrawer");
//     if (cartDrawerInner) {
//       cartDrawerInner.style.transform = "translateX(0)";
//       cartDrawerInner.style.right = "0";
//     }

//     const cartInnerContent = this.querySelector(".cart-drawer__inner");
//     if (cartInnerContent) {
//       cartInnerContent.style.display = "flex";
//       cartInnerContent.style.visibility = "visible";
//       cartInnerContent.style.position = "relative";
//       cartInnerContent.style.right = "0";
//     }

//     const overlay = this.querySelector("#CartDrawer-Overlay");
//     if (overlay) {
//       overlay.classList.add("active");
//       overlay.style.display = "block";
//       overlay.style.opacity = "1";
//       overlay.style.zIndex = "49";
//     }

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true },
//     );
//     document.body.classList.add("overflow-hidden");
//   }

//   close() {
//     this.classList.remove("active", "animate");
//     this.style.display = "none";
//     this.style.visibility = "hidden";

//     const cartDrawerInner = this.querySelector("#CartDrawer");
//     if (cartDrawerInner) {
//       cartDrawerInner.style.transform = "translateX(100%)";
//     }

//     const overlay = this.querySelector("#CartDrawer-Overlay");
//     if (overlay) {
//       overlay.classList.remove("active");
//       overlay.style.display = "none";
//     }

//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove("overflow-hidden");
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");
//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id,
//       );
//     }
//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open"),
//       );
//     });
//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   renderContents(parsedState, autoOpen = true) {
//     if (
//       !parsedState ||
//       !parsedState.items ||
//       !parsedState.sections ||
//       parsedState.total_price === undefined ||
//       parsedState.total_price === null ||
//       isNaN(parsedState.total_price)
//     ) {
//       console.warn("Invalid parsedState in renderContents:", parsedState);
//       return;
//     }
//     //updateCustomerCartMetafield();
//     this.classList.toggle("is-empty", parsedState.items.length === 0);
//     const drawerInnerEmpty = this.querySelector(".drawer__inner-empty");
//     if (drawerInnerEmpty) {
//       drawerInnerEmpty.classList.toggle("hidden", parsedState.items.length > 0);
//     }
//     const cartFooter = this.querySelector(".cart-drawer__footer");
//     if (cartFooter) {
//       cartFooter.classList.toggle("hidden", parsedState.items.length === 0);
//     }
//     const cartDrawerInner = this.querySelector(".cart-drawer__inner");
//     if (
//       cartDrawerInner &&
//       parsedState.sections &&
//       parsedState.sections["cart-drawer"]
//     ) {
//       const parser = new DOMParser();
//       const newContent = parser.parseFromString(
//         parsedState.sections["cart-drawer"],
//         "text/html",
//       );

//       const newInner = newContent.querySelector(".cart-drawer__inner");

//       if (newInner) {
//         cartDrawerInner.innerHTML = newInner.innerHTML;
//       } else {
//         console.error("Failed to find .cart-drawer__inner in parsed sections");
//       }
//     } else {
//       console.error("cart-drawer__inner or sections not found:", {
//         cartDrawerInner,
//         sections: parsedState.sections,
//       });
//     }

//     const totalPrice = parsedState.total_price;
//     const totalsElement = this.querySelector(".totals_drawer p:last-child");
//     if (totalsElement && totalPrice !== undefined) {
//       totalsElement.textContent =
//         "Rp" +
//         (totalPrice / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
//     }

//     const bubble = document.querySelector("#cart-icon-bubble");
//     if (bubble && parsedState.sections["cart-icon-bubble"]) {
//       bubble.innerHTML = new DOMParser()
//         .parseFromString(parsedState.sections["cart-icon-bubble"], "text/html")
//         .querySelector(".shopify-section").innerHTML;
//     }

//     const cartItemsLocalElement = this.querySelector("cart-drawer-items");
//     if (
//       cartItemsLocalElement &&
//       typeof cartItemsLocalElement.renderContents === "function"
//     ) {
//       cartItemsLocalElement.renderContents(parsedState);
//     }

//     if (autoOpen && !this.shouldBlockDrawer()) {
//       this.open(); // always open, empty or not
//     }

//     // Call updates after UI is ready
//     if (parsedState.sections && parsedState.sections["cart-drawer"]) {
//       refreshModalCartDrawerItems(parsedState.sections["cart-drawer"]);
//     }
    
//     if (window.updateDiscountLabels) {
//         window.updateDiscountLabels();
//     }
    
//     updateCustomerCartMetafield(parsedState);
//   }
// }

// // customElements.define("cart-drawer", CartDrawer);
// // customElements.define("cart-drawer-items", CartDrawerItems);

// // function getLocalePrefix() {
// //   const path = window.location.pathname;
// //   const match = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)/);
// //   return match ? "/" + match[1] : "";
// // }

// // function getSectionsUrl() {
// //   return `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`;
// // }

// // function getCartUrl() {
// //   return `${getLocalePrefix()}/cart`;
// // }

// customElements.define("cart-drawer", CartDrawer);
// customElements.define("cart-drawer-items", CartDrawerItems);

// // Locale prefix (only for English and Indonesian)
// function getLocalePrefix() {
//   return window.location.pathname.startsWith("/id") ? "/id" : "";
// }

// function getSectionsUrl() {
//   return `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`;
// }

// function getCartUrl() {
//   return `${getLocalePrefix()}/cart`;
// }

// // Fallback stubs for dependencies
// function trapFocus(container, elementToFocus) {
//   if (!container || !elementToFocus) return;
//   const focusableElements = container.querySelectorAll(
//     'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
//   );
//   const firstElement = focusableElements[0];
//   const lastElement = focusableElements[focusableElements.length - 1];
//   elementToFocus = elementToFocus || firstElement;
//   elementToFocus.focus();
//   container.addEventListener("keydown", (event) => {
//     if (event.key === "Tab") {
//       if (event.shiftKey) {
//         if (document.activeElement === firstElement) {
//           event.preventDefault();
//           lastElement.focus();
//         }
//       } else {
//         if (document.activeElement === lastElement) {
//           event.preventDefault();
//           firstElement.focus();
//         }
//       }
//     }
//   });
// }

// function removeTrapFocus(elementToFocus) {
//   if (elementToFocus) elementToFocus.focus();
// }

// function onKeyUpEscape(event) {
//   if (event.code.toUpperCase() !== "ESCAPE") return;
//   const openDetailsElement = event.target.closest("details[open]");
//   if (!openDetailsElement) return;
//   const summaryElement = openDetailsElement.querySelector("summary");
//   openDetailsElement.removeAttribute("open");
//   summaryElement.setAttribute("aria-expanded", false);
//   summaryElement.focus();
// }
// function refreshModalCartDrawerItems(htmlContent) {
//   const updateDOM = (html) => {
//     const parser = new DOMParser();
//     const newDoc = parser.parseFromString(html, "text/html");
//     const newContent = newDoc.getElementById("ModalCartDrawerItems");

//     const target = document.getElementById("ModalCartDrawerItems");
//     if (target && newContent) {
//       target.innerHTML = newContent.innerHTML;
//       if (window.updateDiscountLabels) window.updateDiscountLabels();
//     }
//   };

//   if (htmlContent) {
//     updateDOM(htmlContent);
//     return;
//   }

//   fetch("/?sections=cart-drawer")
//     .then((res) => res.json())
//     .then((data) => {
//       if (data["cart-drawer"]) updateDOM(data["cart-drawer"]);
//     })
//     .catch((err) =>
//       console.error("Failed to refresh ModalCartDrawerItems:", err),
//     );
//   if (window.updateDiscountLabels) window.updateDiscountLabels();
// }

// document.addEventListener("DOMContentLoaded", () => {
//   const drawer = document.querySelector("cart-drawer");
//   if (drawer) {
//     const observer = new MutationObserver(() => {
//       if (drawer.classList.contains("active")) {
//         document.body.classList.add("drawer-open");
//       } else {
//         document.body.classList.remove("drawer-open");
//       }
//     });
//     observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
//   }
//   // Check if we are on the cart page
//   const isCartPage =
//     window.location.pathname === "/cart" ||
//     window.location.pathname.endsWith("/cart");

//   if (!isCartPage) {
//     fetch("/cart.js")
//       .then((res) => {
//         if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
//         return res.json();
//       })
//       .then(async (cart) => {
//         // await restoreCartFromCustomerMetafield();
//         return fetch(getSectionsUrl()).then((res) => {
//           if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
//           return Promise.all([res.json(), Promise.resolve(cart)]);
//         });
//       })
//       .then(([sections, cart]) => {
//         const cartDrawer = document.querySelector("cart-drawer");
//         if (cartDrawer && typeof cartDrawer.renderContents === "function") {
//           cartDrawer.renderContents(
//             {
//               items: cart.items,
//               sections,
//               total_price: cart.total_price,
//             },
//             false,
//           );
//         } else {
//           console.error(
//             "cart-drawer element or renderContents method not found",
//           );
//         }
//       })
//       .catch((err) => console.error(" Initial cart fetch failed:", err));
//   }

//   //Update cart item sync metafield on remove items from main cart
//   cartRemoveButton();
// });

// function cartRemoveButton() {
//   document
//     .querySelectorAll("#main-cart-items cart-remove-button")
//     ?.forEach((element) => {
//       const link = element.querySelector("a");
//       if (link) {
//         link.addEventListener("click", async (e) => {
//           e.preventDefault();
//           const line = e.target
//             .closest(".cart-item")
//             ?.id?.replace("CartItem-", "");
//           console.log("line", line);
//           if (line && !isNaN(Number(line))) {
//             await fetch("/cart/change.js", {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ line, quantity: 0 }),
//             })
//               .then((res) => res.json())
//               .then((cart) => {
//                 console.log("dfdsfs", cart);
//               });
//             await updateCustomerCartMetafield();
//             location.reload();
//           }
//         });
//       }
//     });
// }

// async function updateCustomerCartMetafield(preFetchedCart = null) {
//   if (!window?.customer?.id) return; // Only run for logged-in users

//   let currentCart = preFetchedCart;
//   if (!currentCart || !currentCart.items) {
//     currentCart = await fetch("/cart.js").then((res) => res.json());
//   }

//   const cartMetaData =
//     typeof window.customer?.metafields?.cart?.itemsdata === "string"
//       ? JSON.parse(window.customer.metafields.cart.itemsdata)
//       : window.customer?.metafields?.cart?.itemsdata || {};

//   console.log("Called cartMetaData", cartMetaData);
//   //if (currentCart?.items?.length === 0) return;
//   const cartData = {
//     items: currentCart?.items.map((item) => ({
//       variant_id: item.variant_id,
//       quantity: item.quantity,
//       properties: item.properties || {}, // line-item attributes
//     })),
//     attributes: currentCart.attributes || {}, // cart-level attributes
//     note: currentCart.note || "",
//   };
//   console.log("cartData structure prepare: ", cartData);
//   const metaUpdateRes = await fetch("/apps/mapclub-production/customer-cart-data", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       customerId: window.customer.id,
//       cartData,
//     }),
//   });
//   const data = await metaUpdateRes.json();
//   console.log("data response", data);
//   // ✅ Safely extract new metafield value
//   const newItemsData = data?.metafield?.value
//     ? data.metafield.value
//     : window.customer?.metafields?.cart?.itemsdata;

//   // ✅ If you need it locally (for logic or display)
//   console.log(newItemsData);
//   window.customer = {
//     ...window.customer,
//     metafields: {
//       ...window.customer?.metafields,
//       cart: {
//         ...window.customer?.metafields?.cart,
//         itemsdata: newItemsData,
//       },
//     },
//   };
// }

// // async function updateCustomerCartMetafield() {
// //   console.log("window?.customer ", window?.customer)
// //   if (!window?.customer?.id) return; // Only run for logged-in users

// //   let currentCart = await fetch('/cart.js').then((res) => res.json());

// //   const cartMetaData = window.customer?.metafields?.cart?.itemsdata ? JSON.parse(window.customer.metafields.cart.itemsdata): {};

// //   console.log("Called cartMetaData", cartMetaData);
// //   //if (currentCart?.items?.length === 0) return;
// //   const cartData = {
// //     items: currentCart?.items.map((item) => ({
// //       variant_id: item.variant_id,
// //       quantity: item.quantity,
// //       properties: item.properties || {}, // line-item attributes
// //     })),
// //     attributes: currentCart.attributes || {}, // cart-level attributes
// //     note: currentCart.note || "",
// //   };
// //   console.log("cartData structure prepare: ", cartData);
// //   const metaUpdateRes = await fetch('/apps/mapclub-production/customer-cart-data', {
// //     method: 'POST',
// //     headers: { 'Content-Type': 'application/json' },
// //     body: JSON.stringify({
// //       customerId: window.customer.id,
// //       cartData,
// //     }),
// //   });
// //   const data = await metaUpdateRes.json();
// //   console.log("data response", data);
// //  // ✅ Safely extract new metafield value
// //   const newItemsData = data?.metafield?.value
// //     ? data.metafield.value
// //     : window.customer?.metafields?.cart?.itemsdata;

// //   // ✅ If you need it locally (for logic or display)
// //   console.log(newItemsData);
// //   window.customer = {
// //     ...window.customer,
// //     metafields: {
// //       ...window.customer?.metafields,
// //       cart: {
// //         ...window.customer?.metafields?.cart,
// //         itemsdata: newItemsData,
// //       },
// //     },
// //   };
// // }

// // Handle cart item removal
// document.addEventListener("click", function (e) {
//   const removeBtn = e.target.closest(".cart-item__remove");
//   if (removeBtn) {
//     e.preventDefault();

//     const line = parseInt(removeBtn.dataset.line);
//     if (!line) return;

//     // Optimistic UI: Hide the item immediately
//     const cartItem = removeBtn.closest(".cart-item_drawer");
//     if (cartItem) {
//       cartItem.style.opacity = "0.5";
//       cartItem.style.pointerEvents = "none";
//     }

//     const cartDrawer = document.querySelector("cart-drawer");

//     // Single fetch for change + sections
//     fetch("/cart/change.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         line,
//         quantity: 0,
//         sections: "cart-drawer,cart-icon-bubble",
//         sections_url: window.location.pathname,
//       }),
//     })
//       .then((res) => res.json())
//       .then((parsedState) => {
//         if (cartDrawer && typeof cartDrawer.renderContents === "function") {
//           cartDrawer.renderContents(parsedState);
//         }

//         // Run metafield update in background (don't await)
//         if (typeof updateCustomerCartMetafield === "function") {
//           updateCustomerCartMetafield();
//         }
//       })
//       .catch((err) => {
//         console.error("Remove failed:", err);
//         window.location.reload();
//       });
//   }
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const cartIcon = document.getElementById("cart-icon-bubble");
//   if (!cartIcon) return;
//   cartIcon.addEventListener(
//     "click",
//     (event) => {
//       if (window.innerWidth <= 1024) {
//         event.preventDefault();
//         event.stopPropagation();
//         const cartUrl = getCartUrl();
//         if (window.location.pathname !== cartUrl) {
//           window.location.href = cartUrl;
//         }
//       }
//     },
//     true,
//   );
// });

// function updateCartCount(quantity) {
//   const cartCountBubble = document.querySelector(
//     "#cart-icon-bubble .cart-count-bubble",
//   );
//   const cartCount = document.querySelector("#cart-icon-bubble .cart-count");

//   if (!cartCountBubble || !cartCount) return;

//   if (quantity > 0) {
//     cartCount.textContent = quantity;
//     cartCountBubble.classList.remove("hidden");
//   } else {
//     cartCount.textContent = 0;
//     cartCountBubble.classList.add("hidden");
//   }
// }

// // Example usage after adding to cart:
// fetch("/cart.js")
//   .then((res) => res.json())
//   .then((cart) => {
//     updateCartCount(cart.item_count);
//   });

// // cart restore from metafield
// async function restoreCartFromCustomerMetafield() {
//   let addAlreadyRun = localStorage.getItem("customerCartChecked");
//   if (!window?.customer?.id && addAlreadyRun) {
//     localStorage.removeItem("customerCartChecked");
//   }
//   if (!window?.customer?.id) return;

//   let cartData = {};
//   try {
//     const metaRaw = window.customer?.metafields?.cart?.itemsdata;
//     if (typeof metaRaw === "string") {
//       cartData = JSON.parse(metaRaw);
//     } else if (typeof metaRaw === "object" && metaRaw !== null) {
//       cartData = metaRaw;
//     }
//   } catch (e) {
//     console.warn("Failed to parse metafield cart", e);
//   }

//   if (!cartData) return;
//   const currentCart = await fetch("/cart.js").then((res) => res.json());

//   // Helper to generate a unique signature for an item
//   const getSignature = (item) => {
//     // 1. Primary Check: _unique_id
//     if (item.properties && item.properties._unique_id) {
//       return item.properties._unique_id;
//     }

//     // 2. Fallback: Variant ID + Sorted Properties
//     const variantId = item.variant_id || item.id;
//     const props = item.properties || {};
//     const sortedKeys = Object.keys(props).sort();
//     const propsString = sortedKeys
//       .map((key) => `${key}:${props[key]}`)
//       .join("|");
//     return `${variantId}-${propsString}`;
//   };

//   const currentSignatures = currentCart.items.map((item) => getSignature(item));
//   const savedSignatures =
//     cartData.items?.map((item) => getSignature(item)) || [];

//   // Track if any changes were made to the cart
//   let cartModified = false;

//   // --- Find mismatched items based on Signatures ---
//   // Items in local cart that are NOT in metafield
//   const mismatchedItems = currentCart.items?.filter((item) => {
//     const sig = getSignature(item);
//     return !savedSignatures.includes(sig);
//   });

//   // Signatures in metafield that are NOT in local cart
//   const mismatchedSignatures = savedSignatures?.filter((sig) => {
//     return !currentSignatures.includes(sig);
//   });

//   // --- Check for Quantity Mismatches ---
//   let quantityMismatch = false;
//   if (
//     !mismatchedItems.length &&
//     !mismatchedSignatures.length &&
//     cartData.items
//   ) {
//     for (const item of currentCart.items) {
//       const sig = getSignature(item);
//       const metaItem = cartData.items.find((i) => getSignature(i) === sig);
//       if (metaItem && metaItem.quantity !== item.quantity) {
//         quantityMismatch = true;
//         break;
//       }
//     }
//   }

//   if (cartData.items?.length === 0 && addAlreadyRun) {
//     await fetch("/cart/clear.js", {
//       method: "POST",
//     });
//     cartModified = true;
//   }

//   if (
//     (mismatchedSignatures.length ||
//       mismatchedItems.length ||
//       quantityMismatch) &&
//     addAlreadyRun &&
//     !cartModified
//   ) {
//     // 1️⃣ Clear the cart
//     await fetch("/cart/clear.js", {
//       method: "POST",
//     });

//     // 2️⃣ Re-add mismatched items from Metafield
//     await fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         items: cartData?.items
//           ?.slice()
//           ?.reverse()
//           ?.map((item) => ({
//             id: item.variant_id,
//             quantity: item.quantity,
//             properties: {
//               ...(item.properties || {}),
//               _unique_id: item.properties?._unique_id || crypto.randomUUID(),
//             },
//           })),
//       }),
//     });
//     cartModified = true;
//   }

//   if (mismatchedItems.length && !cartModified) {
//     // Push logic matching cart.js (mostly a placeholder for merging intent)
//     const newMetaItems = mismatchedItems.map((item) => ({
//       variant_id: item.variant_id,
//       quantity: item.quantity,
//       properties: item.properties || {},
//     }));
//     cartData.items = [...(cartData.items || []), ...newMetaItems];
//     // Mark as modified so the merged state gets pushed to the cloud metafield
//     if (!addAlreadyRun) {
//       cartModified = true;
//     }
//   }

//   // Restore line items from cloud that are missing locally
//   if (cartData?.items?.length && !addAlreadyRun) {
//     // Collect all missing items first
//     const missingItems = cartData.items
//       .filter((item) => {
//         const sig = getSignature(item);
//         return !currentSignatures.includes(sig);
//       })
//       ?.slice()
//       ?.reverse()
//       ?.map((item) => ({
//         id: item.variant_id,
//         quantity: item.quantity,
//         properties: {
//           ...(item.properties || {}),
//           _unique_id: item.properties?._unique_id || crypto.randomUUID(),
//         },
//       }));

//     // Add all missing items in one request
//     if (missingItems.length > 0) {
//       await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ items: missingItems }),
//       });

//       cartModified = true;
//     }
//   }

//   // Restore cart-level attributes
//   if (cartData.attributes && Object.keys(cartData.attributes).length) {
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ attributes: cartData.attributes }),
//     });
//     cartModified = true;
//   }

//   // Restore note
//   if (cartData.note) {
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ note: cartData.note }),
//     });
//     cartModified = true;
//   }

//   localStorage.setItem("customerCartChecked", true);

//   // Only refresh cart drawer/UI if something changed
//   if (cartModified) {
//     try {
//       const cart = await fetch("/cart.js").then((res) => {
//         if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
//         return res.json();
//       });

//       const [sections, updatedCart] = await Promise.all([
//         fetch(getSectionsUrl()).then((res) => {
//           if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
//           return res.json();
//         }),
//         Promise.resolve(cart),
//       ]);

//       updateCartCount(updatedCart.item_count);

//       const cartDrawer = document.querySelector("cart-drawer");
//       if (cartDrawer && typeof cartDrawer.renderContents === "function") {
//         cartDrawer.renderContents(
//           {
//             items: updatedCart.items,
//             sections,
//             total_price: updatedCart.total_price,
//           },
//           false,
//         );

//         // If cart-items section exists in DOM, refresh it
//         let mainCartItems = document.getElementById("main-cart-items");
//         if (mainCartItems) {
//           fetch(`${routes.cart_url}?section_id=main-cart-items`)
//             .then((response) => response.text())
//             .then((responseText) => {
//               const html = new DOMParser().parseFromString(
//                 responseText,
//                 "text/html",
//               );
//               const targetElement = document.querySelector("cart-items");
//               const sourceElement = html.querySelector("cart-items");

//               const sourceQty = html?.querySelector(".js-contents");
//               const currentInBag = mainCartItems.querySelector(".js-contents");
//               if (currentInBag && sourceQty) {
//                 currentInBag.innerHTML = sourceQty.innerHTML;
//               }

//               const sourceSummary = html?.querySelector(".cart-main-box2");
//               const currentSummary = mainCartItems.querySelector(".cart-main-box2");
//               if (currentSummary && sourceSummary) {
//                 currentSummary.innerHTML = sourceSummary.innerHTML;
//               }

//               if (targetElement && sourceElement) {
//                 targetElement.replaceWith(sourceElement);
//               }
//               if (window.reinitializeCartScripts)
//                 window.reinitializeCartScripts();
//             })
//             .catch((e) => {
//               console.error(e);
//             });
//         }

//         await updateCustomerCartMetafield();
//       } else {
//         console.error("cart-drawer element or renderContents method not found");
//       }
//     } catch (err) {
//       console.error("❌ Failed to refresh cart:", err);
//     }
//   }
// }
// // async function restoreCartFromCustomerMetafield() {
// //   let addAlreadyRun = localStorage.getItem("customerCartChecked");
// //   if(!window?.customer?.id && addAlreadyRun) {
// //     localStorage.removeItem("customerCartChecked");
// //   }
// //   if (!window?.customer?.id) return;

// //   let cartData = window.customer?.metafields?.cart?.itemsdata
// //     ? JSON.parse(window.customer.metafields.cart.itemsdata)
// //     : {};

// //   if (!cartData) return;
// //   const currentCart = await fetch("/cart.js").then((res) => res.json());
// //   //const currentIds = currentCart.items.map((item) => item.properties?._unique_id);
// //   const currentIds = currentCart.items.map((item) => item.id);

// //   //const savedIds = cartData.items?.map((item) => item.properties?._unique_id) || [];
// //   const savedIds = cartData.items?.map((item) => item.variant_id) || [];
// //   // Track if any changes were made to the cart
// //   let cartModified = false;
// //   // --- Find mismatched items ---
// //   const mismatchedItems = currentCart.items?.filter((item) => {
// //     //const id = item.properties?._unique_id;
// //     const id = item.id;
// //     return !id || !savedIds.includes(id); // missing or not present in metafield data
// //   });

// //   const mismatchedIds = savedIds?.filter((id) => {
// //     return !id || !currentIds.includes(id);
// //   })
// //   if(cartData.items?.length === 0 && addAlreadyRun) {
// //     console.log("cart condition first: 1");
// //     await fetch("/cart/clear.js", {
// //       method: "POST",
// //     });
// //     cartModified = true;
// //   }
// //   if (mismatchedIds.length && addAlreadyRun && !cartModified) {
// //     console.log("cart condition second: 2");
// //     // 1️⃣ Clear the cart
// //     await fetch("/cart/clear.js", {
// //       method: "POST",
// //     });

// //     // 2️⃣ Re-add mismatched items
// //     await fetch("/cart/add.js", {
// //       method: "POST",
// //       headers: {
// //         "Content-Type": "application/json",
// //       },
// //       body: JSON.stringify({
// //         items: cartData?.items?.slice()?.reverse()?.map((item) => ({
// //           id: item.variant_id,
// //           quantity: item.quantity,
// //           properties: item.properties || {},
// //         })),
// //       }),
// //     });
// //     cartModified = true;
// //   }

// //   if (mismatchedItems.length) {
// //     console.log("cart condition third: 3");
// //     cartData.items = [
// //       ...cartData.items,
// //       ...mismatchedItems.map((item) => ({
// //         variant_id: item.variant_id,
// //         quantity: item.quantity,
// //         properties: item.properties || {},
// //       })),
// //     ];
// //   }
// //   console.log("currentIds", currentIds, "savedIds", savedIds, "mismatchedItems", mismatchedItems, "mismatchedIds", mismatchedIds, "cartModified", cartModified, "addAlreadyRun", addAlreadyRun)
// //   // Restore line items only if cart is empty and saved data exists
// //   if (cartData?.items?.length && !addAlreadyRun && !cartModified) {
// //     console.log("cart condition fourth: 4");
// //     // Collect all missing items first
// //     const missingItems = cartData.items
// //       //.filter((item) => !currentIds.includes(item.properties?._unique_id))
// //       .filter((item) => !currentIds.includes(item.variant_id))
// //       ?.slice()?.reverse()?.map((item) => ({
// //         id: item.variant_id,
// //         quantity: item.quantity,
// //         properties: item.properties || {},
// //       }));
// //     // Add all missing items in one request
// //     if (missingItems.length > 0) {
// //       console.log("cart condition fifth: 5");
// //       await fetch("/cart/add.js", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ items: missingItems }),
// //       });

// //       cartModified = true;
// //     }

// //     // Restore cart-level attributes
// //     if (cartData.attributes && Object.keys(cartData.attributes).length) {
// //       await fetch("/cart/update.js", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ attributes: cartData.attributes }),
// //       });
// //       cartModified = true;
// //     }

// //     // Restore note
// //     if (cartData.note) {
// //       await fetch("/cart/update.js", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ note: cartData.note }),
// //       });
// //       cartModified = true;
// //     }
// //     localStorage.setItem("customerCartChecked", true);
// //   }

// //   // Only refresh cart drawer if something changed
// //   if (cartModified) {
// //     try {
// //       const cart = await fetch("/cart.js").then((res) => {
// //         if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
// //         return res.json();
// //       });

// //       const [sections, updatedCart] = await Promise.all([
// //         fetch(getSectionsUrl()).then((res) => {
// //           if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
// //           return res.json();
// //         }),
// //         Promise.resolve(cart),
// //       ]);
// //       const cartDrawer = document.querySelector("cart-drawer");
// //       if (cartDrawer && typeof cartDrawer.renderContents === "function") {
// //         cartDrawer.renderContents(
// //           {
// //             items: updatedCart.items,
// //             sections,
// //             total_price: updatedCart.total_price,
// //           },
// //           false
// //         );

// //         // 🔥 New addition: If cart-items section exists in DOM, refresh it
// //         let mainCartItems = document.getElementById('main-cart-items');
// //         if (mainCartItems) {
// //           fetch(`${routes.cart_url}?section_id=main-cart-items`)
// //           .then((response) => response.text())
// //           .then((responseText) => {
// //             const html = new DOMParser().parseFromString(responseText, 'text/html');
// //             const sourceQty = html.querySelector('.js-contents');
// //             mainCartItems.querySelector('.js-contents').innerHTML = sourceQty.innerHTML;
// //           })
// //           .catch((e) => {
// //             console.error(e);
// //           });
// //         }

// //         await updateCustomerCartMetafield();
// //       } else {
// //         console.error("cart-drawer element or renderContents method not found");
// //       }
// //     } catch (err) {
// //       console.error("❌ Failed to refresh cart:", err);
// //     }
// //   }
// // }

// document.addEventListener("DOMContentLoaded", () => {
//   const isCartPage =
//     window.location.pathname === "/cart" ||
//     window.location.pathname.endsWith("/cart");
//   if (!isCartPage) {
//     restoreCartFromCustomerMetafield();
//   }
// });



// assets/cart-drawer.js

// Placeholder for CartItems class (assumed to be defined elsewhere, e.g., global.js)
// If not defined, this minimal version prevents errors

class CartItems extends HTMLElement {
  constructor() {
    super();
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".cart-drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  

  renderContents(parsedState) {
    // Update cart items list
    this.classList.toggle("is-empty", parsedState.items.length === 0);
    if (parsedState.sections && parsedState.sections["cart-drawer"]) {
      const cartItemsList = this.querySelector(".cart-items");
      if (cartItemsList) {
        cartItemsList.innerHTML = new DOMParser()
          .parseFromString(parsedState.sections["cart-drawer"], "text/html")
          .querySelector(".cart-items").innerHTML;
        cartItemsList.classList.toggle(
          "is-empty",
          parsedState.items.length === 0,
        );
      }
    }
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    // Escape key to close drawer
    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") {
        this.close();
      }
    });

    // Overlay click to close drawer
    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }

    // Close button
    const closeButton = this.querySelector(".drawer__close");
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    const shouldBlockDrawer = () => {
      const path = window.location.pathname;
      return (
        path === "/cart" ||
        path === /^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/cart$/.test(path)
      );
    };
    cartLink.addEventListener("click", (event) => {
      if (shouldBlockDrawer()) {
        return;
      }
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (shouldBlockDrawer()) {
        return;
      }
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  shouldBlockDrawer() {
    const path = window.location.pathname;
    return (
      path === "/cart" ||
      path === /^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/cart$/.test(path)
    );
  }
  open(triggeredBy) {
    if (this.shouldBlockDrawer()) {
      return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    this.classList.add("animate", "active");
    this.style.display = "block";
    this.style.visibility = "visible";

    const cartDrawerInner = this.querySelector("#CartDrawer");
    if (cartDrawerInner) {
      cartDrawerInner.style.transform = "translateX(0)";
      cartDrawerInner.style.right = "0";
    }

    const cartInnerContent = this.querySelector(".cart-drawer__inner");
    if (cartInnerContent) {
      cartInnerContent.style.display = "flex";
      cartInnerContent.style.visibility = "visible";
      cartInnerContent.style.position = "relative";
      cartInnerContent.style.right = "0";
    }

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.classList.add("active");
      overlay.style.display = "block";
      overlay.style.opacity = "1";
      overlay.style.zIndex = "49";
    }

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active", "animate");
    this.style.display = "none";
    this.style.visibility = "hidden";

    const cartDrawerInner = this.querySelector("#CartDrawer");
    if (cartDrawerInner) {
      cartDrawerInner.style.transform = "translateX(100%)";
    }

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.classList.remove("active");
      overlay.style.display = "none";
    }

    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, autoOpen = true) {
    if (
      !parsedState ||
      !parsedState.items ||
      !parsedState.sections ||
      parsedState.total_price === undefined ||
      parsedState.total_price === null ||
      isNaN(parsedState.total_price)
    ) {
      console.warn("Invalid parsedState in renderContents:", parsedState);
      return;
    }
    //updateCustomerCartMetafield();
    this.classList.toggle("is-empty", parsedState.items.length === 0);
    const drawerInnerEmpty = this.querySelector(".drawer__inner-empty");
    if (drawerInnerEmpty) {
      drawerInnerEmpty.classList.toggle("hidden", parsedState.items.length > 0);
    }
    const cartFooter = this.querySelector(".cart-drawer__footer");
    if (cartFooter) {
      cartFooter.classList.toggle("hidden", parsedState.items.length === 0);
    }
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (
      cartDrawerInner &&
      parsedState.sections &&
      parsedState.sections["cart-drawer"]
    ) {
      const parser = new DOMParser();
      const newContent = parser.parseFromString(
        parsedState.sections["cart-drawer"],
        "text/html",
      );

      const newInner = newContent.querySelector(".cart-drawer__inner");

      if (newInner) {
        cartDrawerInner.innerHTML = newInner.innerHTML;
      } else {
        console.error("Failed to find .cart-drawer__inner in parsed sections");
      }
    } else {
      console.error("cart-drawer__inner or sections not found:", {
        cartDrawerInner,
        sections: parsedState.sections,
      });
    }

    const totalPrice = parsedState.total_price;
    if (totalPrice !== undefined) {
      updateCartDrawerSummary(totalPrice);
    }

    const bubble = document.querySelector("#cart-icon-bubble");
    if (bubble && parsedState.sections["cart-icon-bubble"]) {
      bubble.innerHTML = new DOMParser()
        .parseFromString(parsedState.sections["cart-icon-bubble"], "text/html")
        .querySelector(".shopify-section").innerHTML;
    }

    const cartItemsLocalElement = this.querySelector("cart-drawer-items");
    if (
      cartItemsLocalElement &&
      typeof cartItemsLocalElement.renderContents === "function"
    ) {
      cartItemsLocalElement.renderContents(parsedState);
    }

    if (autoOpen && !this.shouldBlockDrawer()) {
      this.open(); // always open, empty or not
    }

    // Call updates after UI is ready
    if (parsedState.sections && parsedState.sections["cart-drawer"]) {
      refreshModalCartDrawerItems(parsedState.sections["cart-drawer"]);
    }
    
    if (window.updateDiscountLabels) {
        window.updateDiscountLabels();
    }
    
    updateCustomerCartMetafield(parsedState);
  }
}



customElements.define("cart-drawer", CartDrawer);
customElements.define("cart-drawer-items", CartDrawerItems);

// Locale prefix (only for English and Indonesian)
function getLocalePrefix() {
  return window.location.pathname.startsWith("/id") ? "/id" : "";
}

function getSectionsUrl() {
  return `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`;
}

function getCartUrl() {
  return `${getLocalePrefix()}/cart`;
}

// Fallback stubs for dependencies
function trapFocus(container, elementToFocus) {
  if (!container || !elementToFocus) return;
  const focusableElements = container.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  );
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  elementToFocus = elementToFocus || firstElement;
  elementToFocus.focus();
  container.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  });
}

function removeTrapFocus(elementToFocus) {
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
function refreshModalCartDrawerItems(htmlContent) {
  const updateDOM = (html) => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, "text/html");
    const newContent = newDoc.getElementById("ModalCartDrawerItems");

    const target = document.getElementById("ModalCartDrawerItems");
    if (target && newContent) {
      target.innerHTML = newContent.innerHTML;
      if (window.updateDiscountLabels) window.updateDiscountLabels();
    }
  };

  if (htmlContent) {
    updateDOM(htmlContent);
    return;
  }

  fetch("/?sections=cart-drawer")
    .then((res) => res.json())
    .then((data) => {
      if (data["cart-drawer"]) updateDOM(data["cart-drawer"]);
    })
    .catch((err) =>
      console.error("Failed to refresh ModalCartDrawerItems:", err),
    );
  if (window.updateDiscountLabels) window.updateDiscountLabels();
}

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const observer = new MutationObserver(() => {
      if (drawer.classList.contains("active")) {
        document.body.classList.add("drawer-open");
      } else {
        document.body.classList.remove("drawer-open");
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
  // Check if we are on the cart page
  const isCartPage =
    window.location.pathname === "/cart" ||
    window.location.pathname.endsWith("/cart");

  if (!isCartPage) {
    fetch("/cart.js")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then(async (cart) => {
        // await restoreCartFromCustomerMetafield();
        return fetch(getSectionsUrl()).then((res) => {
          if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
          return Promise.all([res.json(), Promise.resolve(cart)]);
        });
      })
      .then(([sections, cart]) => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(
            {
              items: cart.items,
              sections,
              total_price: cart.total_price,
            },
            false,
          );
        } else {
          console.error(
            "cart-drawer element or renderContents method not found",
          );
        }
      })
      .catch((err) => console.error(" Initial cart fetch failed:", err));
  }

  //Update cart item sync metafield on remove items from main cart
  cartRemoveButton();
});

function cartRemoveButton() {
  document
    .querySelectorAll("#main-cart-items cart-remove-button")
    ?.forEach((element) => {
      const link = element.querySelector("a");
      if (link) {
        link.addEventListener("click", async (e) => {
          e.preventDefault();
          const line = e.target
            .closest(".cart-item")
            ?.id?.replace("CartItem-", "");
          console.log("line", line);
          if (line && !isNaN(Number(line))) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line, quantity: 0 }),
            })
              .then((res) => res.json())
              .then((cart) => {
                console.log("dfdsfs", cart);
              });
            await updateCustomerCartMetafield();
            location.reload();
          }
        });
      }
    });
}

async function updateCustomerCartMetafield(preFetchedCart = null) {
  if (!window?.customer?.id) return; // Only run for logged-in users

  let currentCart = preFetchedCart;
  if (!currentCart || !currentCart.items) {
    console.log("[CART-DEBUG] updateCustomerCartMetafield: GET /cart.js started");
    const _metaCartRes = await fetch("/cart.js");
    const _metaCartCt = _metaCartRes.headers.get("content-type") || "unknown";
    console.log(
      `[CART-DEBUG] updateCustomerCartMetafield: GET /cart.js responded status=${_metaCartRes.status} content-type="${_metaCartCt}"`
    );
    // Shopify .js endpoints return "text/javascript" not "application/json"
    // Only reject if not OK or content-type is "text/html" (error pages)
    if (!_metaCartRes.ok || _metaCartCt.includes("text/html")) {
      const _rawBody = await _metaCartRes.text();
      console.error(
        `[CART-DEBUG] updateCustomerCartMetafield: Error or HTML from /cart.js (status=${_metaCartRes.status}). First 200 chars:`,
        _rawBody.substring(0, 200)
      );
      throw new Error(`updateCustomerCartMetafield: cart.js failed (HTTP ${_metaCartRes.status})`);
    }
    currentCart = await _metaCartRes.json();
  }

  const cartMetaData =
    typeof window.customer?.metafields?.cart?.itemsdata === "string"
      ? JSON.parse(window.customer.metafields.cart.itemsdata)
      : window.customer?.metafields?.cart?.itemsdata || {};

  console.log("Called cartMetaData", cartMetaData);
  //if (currentCart?.items?.length === 0) return;
  const cartData = {
    items: currentCart?.items.map((item) => ({
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {}, // line-item attributes
    })),
    attributes: currentCart.attributes || {}, // cart-level attributes
    note: currentCart.note || "",
  };
  console.log("[CART-DEBUG] updateCustomerCartMetafield: POST Mapclub customer-cart-data started");
  const metaUpdateRes = await window.mapclubFetch("customer-cart-data", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      customerId: window.customer.id,
      cartData,
    }),
  });
  const _metaCt = metaUpdateRes.headers.get("content-type") || "unknown";
  console.log(
    `[CART-DEBUG] updateCustomerCartMetafield: POST responded status=${metaUpdateRes.status} content-type="${_metaCt}"`
  );
  let data;
  // For app proxy endpoint, also accept text/javascript
  if (!metaUpdateRes.ok || _metaCt.includes("text/html")) {
    const _rawMeta = await metaUpdateRes.text();
    console.error(
      `[CART-DEBUG] updateCustomerCartMetafield: Non-JSON response (status=${metaUpdateRes.status}). First 200 chars:`,
      _rawMeta.substring(0, 200)
    );
    data = {};
  } else {
    data = await metaUpdateRes.json();
  }
  console.log("[CART-DEBUG] updateCustomerCartMetafield: data response", data);
  // ✅ Safely extract new metafield value
  const newItemsData = data?.metafield?.value
    ? data.metafield.value
    : window.customer?.metafields?.cart?.itemsdata;

  // ✅ If you need it locally (for logic or display)
  console.log(newItemsData);
  window.customer = {
    ...window.customer,
    metafields: {
      ...window.customer?.metafields,
      cart: {
        ...window.customer?.metafields?.cart,
        itemsdata: newItemsData,
      },
    },
  };
}

// async function updateCustomerCartMetafield() {
//   console.log("window?.customer ", window?.customer)
//   if (!window?.customer?.id) return; // Only run for logged-in users

//   let currentCart = await fetch('/cart.js').then((res) => res.json());

//   const cartMetaData = window.customer?.metafields?.cart?.itemsdata ? JSON.parse(window.customer.metafields.cart.itemsdata): {};

//   console.log("Called cartMetaData", cartMetaData);
//   //if (currentCart?.items?.length === 0) return;
//   const cartData = {
//     items: currentCart?.items.map((item) => ({
//       variant_id: item.variant_id,
//       quantity: item.quantity,
//       properties: item.properties || {}, // line-item attributes
//     })),
//     attributes: currentCart.attributes || {}, // cart-level attributes
//     note: currentCart.note || "",
//   };
//   console.log("cartData structure prepare: ", cartData);
//   const metaUpdateRes = await fetch('/apps/mapclub-production/customer-cart-data', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       customerId: window.customer.id,
//       cartData,
//     }),
//   });
//   const data = await metaUpdateRes.json();
//   console.log("data response", data);
//  // ✅ Safely extract new metafield value
//   const newItemsData = data?.metafield?.value
//     ? data.metafield.value
//     : window.customer?.metafields?.cart?.itemsdata;

//   // ✅ If you need it locally (for logic or display)
//   console.log(newItemsData);
//   window.customer = {
//     ...window.customer,
//     metafields: {
//       ...window.customer?.metafields,
//       cart: {
//         ...window.customer?.metafields?.cart,
//         itemsdata: newItemsData,
//       },
//     },
//   };
// }

const cartDrawerOptimisticQuantities = new Map();
let cartDrawerOptimisticTotalPrice = null;
const cartDrawerPendingUpdates = new Map();
let cartDrawerFlushTimer = null;
let cartDrawerFlushInFlight = false;
let cartDrawerFlushQueued = false;
let cartDrawerLastServerState = null;
const CART_DRAWER_FREE_SHIPPING_THRESHOLD = 99000000;
const CART_DRAWER_REMOVE_FLUSH_DELAY = 120;

function formatDrawerMoneyFromCents(cents) {
  const normalizedCents = Math.max(0, Number(cents) || 0);
  const amount = Math.round(normalizedCents / 100);
  return `Rp${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
}

function parseDisplayedMoneyToCents(text) {
  const digits = String(text || "").replace(/[^\d]/g, "");
  if (!digits) return 0;
  return parseInt(digits, 10) * 100;
}

function getCartDrawerTotalPriceCents() {
  const totalElement = document.querySelector("cart-drawer .totals_drawer p:last-child");
  return parseDisplayedMoneyToCents(totalElement?.textContent);
}

function getCartDrawerLinePriceCents(cartItem) {
  if (!cartItem) return 0;

  const selectors = [
    ".price-item--sale",
    ".price-item--regular",
    ".money",
    ".cart-item__price",
  ];

  for (const selector of selectors) {
    const cents = parseDisplayedMoneyToCents(
      cartItem.querySelector(selector)?.textContent,
    );
    if (cents > 0) {
      return cents;
    }
  }

  return 0;
}

function updateDrawerItemCount(delta) {
  if (!delta) return;

  const drawerCount = document.querySelector(
    "cart-drawer .cart-drawer__item-count",
  );
  if (drawerCount) {
    const currentCount = parseInt(drawerCount.dataset.count || "0", 10);
    const nextCount = Math.max(0, currentCount + delta);
    drawerCount.dataset.count = String(nextCount);

    const singularLabel = drawerCount.dataset.labelOne || "1 item";
    const pluralTemplate = drawerCount.dataset.labelOther || "2 items";
    drawerCount.textContent =
      nextCount === 1
        ? singularLabel.replace(/\d+/, String(nextCount))
        : pluralTemplate.replace(/\d+/, String(nextCount));
  } else {
    const drawerTitle = document.querySelector("cart-drawer .drawer__header h2");
    if (drawerTitle) {
      const nextText = drawerTitle.textContent.replace(
        /\((\d+)(?:\s+[^\)]*)?\)\s*$/,
        (_, count) => {
          const nextCount = Math.max(0, parseInt(count, 10) + delta);
          return `(${nextCount})`;
        },
      );
      drawerTitle.textContent = nextText;
    }
  }

  document
    .querySelectorAll('.cart-count-bubble span[aria-hidden="true"]')
    .forEach((bubble) => {
      const count = parseInt(bubble.textContent.replace(/\D/g, ""), 10);
      if (Number.isFinite(count)) {
        bubble.textContent = Math.max(0, count + delta);
      }
    });
}

function updateCartDrawerSummary(totalCents) {
  const normalizedTotal = Math.max(0, Number(totalCents) || 0);
  const totalElement = document.querySelector("cart-drawer .totals_drawer p:last-child");
  if (totalElement) {
    totalElement.textContent = formatDrawerMoneyFromCents(normalizedTotal);
  }

  const progressFill = document.querySelector("cart-drawer .progress-bar__fill");
  if (progressFill) {
    const progress = Math.min(
      100,
      (normalizedTotal / CART_DRAWER_FREE_SHIPPING_THRESHOLD) * 100,
    );
    progressFill.style.width = `${progress}%`;
  }

  const progressText = document.querySelector("cart-drawer .progress-text");
  if (progressText) {
    const strings = window.cartStrings || {};
    if (normalizedTotal >= CART_DRAWER_FREE_SHIPPING_THRESHOLD) {
      progressText.innerHTML =
        (strings.free_shipping_achieved ||
          "Congratulations! You have qualified for free shipping") +
        ` <strong>${strings.free_shipping_bold || "FREE Shipping"}</strong>`;
    } else {
      const remaining = CART_DRAWER_FREE_SHIPPING_THRESHOLD - normalizedTotal;
      const formattedRemaining = formatDrawerMoneyFromCents(remaining).replace(
        "Rp",
        "",
      );
      progressText.innerHTML =
        `${strings.add_rp || "Add Rp"}${formattedRemaining}&nbsp;` +
        `${strings.free_shipping_more || "more for"} ` +
        `<strong>${strings.free_shipping_bold || "FREE Shipping"}</strong>`;
    }
  }
}

function animateDrawerItemRemoval(cartItem) {
  if (!cartItem) {
    return () => {};
  }

  const stylesToRestore = {
    transition: cartItem.style.transition,
    opacity: cartItem.style.opacity,
    transform: cartItem.style.transform,
    height: cartItem.style.height,
    marginTop: cartItem.style.marginTop,
    marginBottom: cartItem.style.marginBottom,
    paddingTop: cartItem.style.paddingTop,
    paddingBottom: cartItem.style.paddingBottom,
    overflow: cartItem.style.overflow,
    pointerEvents: cartItem.style.pointerEvents,
  };

  const itemHeight = cartItem.getBoundingClientRect().height;
  cartItem.style.height = `${itemHeight}px`;
  cartItem.style.overflow = "hidden";
  cartItem.style.pointerEvents = "none";

  requestAnimationFrame(() => {
    cartItem.style.transition =
      "opacity 180ms ease, transform 180ms ease, height 220ms ease, margin 220ms ease, padding 220ms ease";
    cartItem.style.opacity = "0";
    cartItem.style.transform = "translateX(12px)";
    cartItem.style.height = "0px";
    cartItem.style.marginTop = "0px";
    cartItem.style.marginBottom = "0px";
    cartItem.style.paddingTop = "0px";
    cartItem.style.paddingBottom = "0px";
  });

  return () => {
    Object.entries(stylesToRestore).forEach(([key, value]) => {
      cartItem.style[key] = value;
    });
  };
}

function syncCartDrawerLineQuantity(key, quantity) {
  document
    .querySelectorAll(`cart-drawer .cart-item__remove[data-key="${CSS.escape(key)}"]`)
    .forEach((button) => {
      button.dataset.currentQuantity = String(quantity);
    });
}

function scheduleCartDrawerFlush(immediate = false) {
  if (cartDrawerFlushTimer) {
    clearTimeout(cartDrawerFlushTimer);
  }

  if (immediate) {
    flushCartDrawerUpdates();
    return;
  }

  cartDrawerFlushTimer = setTimeout(() => {
    cartDrawerFlushTimer = null;
    flushCartDrawerUpdates();
  }, CART_DRAWER_REMOVE_FLUSH_DELAY);
}

async function flushCartDrawerUpdates() {
  if (cartDrawerFlushInFlight || cartDrawerPendingUpdates.size === 0) {
    if (cartDrawerFlushInFlight) {
      cartDrawerFlushQueued = true;
    }
    return;
  }

  cartDrawerFlushInFlight = true;
  cartDrawerFlushQueued = false;
  const cartDrawer = document.querySelector("cart-drawer");
  const updates = {};
  cartDrawerPendingUpdates.forEach((quantity, key) => {
    updates[key] = quantity;
  });
  cartDrawerPendingUpdates.clear();

  try {
    const res = await fetch(`${getLocalePrefix()}/cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname,
      }),
    });

    if (!res.ok) {
      throw new Error(`Cart update failed (HTTP ${res.status})`);
    }

    const parsedState = await res.json();
    if (!parsedState || !parsedState.sections || !Array.isArray(parsedState.items)) {
      throw new Error("Cart update returned an invalid payload");
    }

    cartDrawerLastServerState = parsedState;

    if (
      cartDrawerPendingUpdates.size === 0 &&
      !cartDrawerFlushQueued &&
      cartDrawerLastServerState &&
      cartDrawer &&
      typeof cartDrawer.renderContents === "function"
    ) {
      cartDrawer.renderContents(cartDrawerLastServerState, false);
      cartDrawerOptimisticQuantities.clear();
      cartDrawerOptimisticTotalPrice = null;
    }
  } catch (err) {
    console.error("Remove failed:", err);
    cartDrawerOptimisticQuantities.clear();
    cartDrawerOptimisticTotalPrice = null;
    cartDrawerPendingUpdates.clear();
    window.location.reload();
  } finally {
    cartDrawerFlushInFlight = false;
    if (cartDrawerPendingUpdates.size > 0 || cartDrawerFlushQueued) {
      scheduleCartDrawerFlush(true);
    }
  }
}

// Handle cart item removal
document.addEventListener("click", async function (e) {
  const removeBtn = e.target.closest(".cart-item__remove");
  if (removeBtn) {
    e.preventDefault();
    e.stopPropagation();

    if (removeBtn.disabled) {
      return;
    }

    const key = removeBtn.dataset.key;
    if (!key) return;

    const domQuantity = parseInt(removeBtn.dataset.currentQuantity, 10);
    const currentQuantity = cartDrawerOptimisticQuantities.has(key)
      ? cartDrawerOptimisticQuantities.get(key)
      : domQuantity;

    if (!Number.isFinite(currentQuantity) || currentQuantity <= 0) {
      return;
    }

    const nextQuantity = currentQuantity - 1;
    cartDrawerOptimisticQuantities.set(key, nextQuantity);
    syncCartDrawerLineQuantity(key, nextQuantity);

    // Optimistic UI: collapse the removed visual row immediately
    const cartItem = removeBtn.closest(".cart-item_drawer");
    const linePriceCents = getCartDrawerLinePriceCents(cartItem);
    animateDrawerItemRemoval(cartItem);
    updateDrawerItemCount(-1);
    const currentTotalCents =
      cartDrawerOptimisticTotalPrice ?? getCartDrawerTotalPriceCents();
    const nextTotalCents = Math.max(0, currentTotalCents - linePriceCents);
    cartDrawerOptimisticTotalPrice = nextTotalCents;
    updateCartDrawerSummary(nextTotalCents);

    cartDrawerPendingUpdates.set(key, nextQuantity);

    if (nextQuantity <= 0) {
      cartDrawerOptimisticQuantities.delete(key);
    }

    scheduleCartDrawerFlush();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const cartIcon = document.getElementById("cart-icon-bubble");
  if (!cartIcon) return;
  cartIcon.addEventListener(
    "click",
    (event) => {
      if (window.innerWidth <= 1024) {
        event.preventDefault();
        event.stopPropagation();
        const cartUrl = getCartUrl();
        if (window.location.pathname !== cartUrl) {
          window.location.href = cartUrl;
        }
      }
    },
    true,
  );
});

function updateCartCount(quantity) {
  const cartCountBubble = document.querySelector(
    "#cart-icon-bubble .cart-count-bubble",
  );
  const cartCount = document.querySelector("#cart-icon-bubble .cart-count");

  if (!cartCountBubble || !cartCount) return;

  if (quantity > 0) {
    cartCount.textContent = quantity;
    cartCountBubble.classList.remove("hidden");
  } else {
    cartCount.textContent = 0;
    cartCountBubble.classList.add("hidden");
  }
}

// Example usage after adding to cart:
console.log("[CART-DEBUG] cart-drawer.js top-level: GET /cart.js on page load");
fetch("/cart.js")
  .then((res) => {
    console.log(`[CART-DEBUG] cart-drawer.js top-level: /cart.js responded status=${res.status}`);
    if (!res.ok) {
      return res.text().then((_raw) => {
        console.error(`[CART-DEBUG] cart-drawer.js top-level: Non-OK /cart.js. First 200 chars:`, _raw.substring(0, 200));
        return null;
      });
    }
    return res.json();
  })
  .then((cart) => {
    if (cart) updateCartCount(cart.item_count);
  })
  .catch((err) => console.error("[CART-DEBUG] cart-drawer.js top-level /cart.js error:", err));

// cart restore from metafield
async function restoreCartFromCustomerMetafield() {
  console.log("[CART-DEBUG] restoreCartFromCustomerMetafield: START");
  let addAlreadyRun = localStorage.getItem("customerCartChecked");
  if (!window?.customer?.id && addAlreadyRun) {
    localStorage.removeItem("customerCartChecked");
  }
  if (!window?.customer?.id) {
    console.log("[CART-DEBUG] restoreCartFromCustomerMetafield: No customer, skipping");
    return;
  }

  let cartData = {};
  try {
    const metaRaw = window.customer?.metafields?.cart?.itemsdata;
    if (typeof metaRaw === "string") {
      cartData = JSON.parse(metaRaw);
    } else if (typeof metaRaw === "object" && metaRaw !== null) {
      cartData = metaRaw;
    }
  } catch (e) {
    console.warn("Failed to parse metafield cart", e);
  }

  if (!cartData) return;
  console.log("[CART-DEBUG] restoreCartFromCustomerMetafield: GET /cart.js started");
  const _restoreCartRes = await fetch("/cart.js");
  console.log(`[CART-DEBUG] restoreCartFromCustomerMetafield: GET /cart.js responded status=${_restoreCartRes.status}`);
  if (!_restoreCartRes.ok) {
    const _rawBody = await _restoreCartRes.text();
    console.error(
      `[CART-DEBUG] restoreCartFromCustomerMetafield: Non-OK /cart.js (status=${_restoreCartRes.status}). First 200 chars:`,
      _rawBody.substring(0, 200)
    );
    return; // Don't proceed if cart fetch failed
  }
  const currentCart = await _restoreCartRes.json();

  // Helper to generate a unique signature for an item
  const getSignature = (item) => {
    // 1. Primary Check: _unique_id
    if (item.properties && item.properties._unique_id) {
      return item.properties._unique_id;
    }

    // 2. Fallback: Variant ID + Sorted Properties
    const variantId = item.variant_id || item.id;
    const props = item.properties || {};
    const sortedKeys = Object.keys(props).sort();
    const propsString = sortedKeys
      .map((key) => `${key}:${props[key]}`)
      .join("|");
    return `${variantId}-${propsString}`;
  };

  const currentSignatures = currentCart.items.map((item) => getSignature(item));
  const savedSignatures =
    cartData.items?.map((item) => getSignature(item)) || [];

  // Track if any changes were made to the cart
  let cartModified = false;

  // --- Find mismatched items based on Signatures ---
  // Items in local cart that are NOT in metafield
  const mismatchedItems = currentCart.items?.filter((item) => {
    const sig = getSignature(item);
    return !savedSignatures.includes(sig);
  });

  // Signatures in metafield that are NOT in local cart
  const mismatchedSignatures = savedSignatures?.filter((sig) => {
    return !currentSignatures.includes(sig);
  });

  // --- Check for Quantity Mismatches ---
  let quantityMismatch = false;
  if (
    !mismatchedItems.length &&
    !mismatchedSignatures.length &&
    cartData.items
  ) {
    for (const item of currentCart.items) {
      const sig = getSignature(item);
      const metaItem = cartData.items.find((i) => getSignature(i) === sig);
      if (metaItem && metaItem.quantity !== item.quantity) {
        quantityMismatch = true;
        break;
      }
    }
  }

  if (cartData.items?.length === 0 && addAlreadyRun) {
    await fetch("/cart/clear.js", {
      method: "POST",
    });
    cartModified = true;
  }

  if (
    (mismatchedSignatures.length ||
      mismatchedItems.length ||
      quantityMismatch) &&
    addAlreadyRun &&
    !cartModified
  ) {
    // 1️⃣ Clear the cart
    await fetch("/cart/clear.js", {
      method: "POST",
    });

    // 2️⃣ Re-add mismatched items from Metafield
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: cartData?.items
          ?.slice()
          ?.reverse()
          ?.map((item) => ({
            id: item.variant_id,
            quantity: item.quantity,
            properties: {
              ...(item.properties || {}),
              _unique_id: item.properties?._unique_id || crypto.randomUUID(),
            },
          })),
      }),
    });
    cartModified = true;
  }

  if (mismatchedItems.length && !cartModified) {
    // Push logic matching cart.js (mostly a placeholder for merging intent)
    const newMetaItems = mismatchedItems.map((item) => ({
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {},
    }));
    cartData.items = [...(cartData.items || []), ...newMetaItems];
    // Mark as modified so the merged state gets pushed to the cloud metafield
    if (!addAlreadyRun) {
      cartModified = true;
    }
  }

  // Restore line items from cloud that are missing locally
  if (cartData?.items?.length && !addAlreadyRun) {
    // Collect all missing items first
    const missingItems = cartData.items
      .filter((item) => {
        const sig = getSignature(item);
        return !currentSignatures.includes(sig);
      })
      ?.slice()
      ?.reverse()
      ?.map((item) => ({
        id: item.variant_id,
        quantity: item.quantity,
        properties: {
          ...(item.properties || {}),
          _unique_id: item.properties?._unique_id || crypto.randomUUID(),
        },
      }));

    // Add all missing items in one request
    if (missingItems.length > 0) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: missingItems }),
      });

      cartModified = true;
    }
  }

  // Restore cart-level attributes
  if (cartData.attributes && Object.keys(cartData.attributes).length) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: cartData.attributes }),
    });
    cartModified = true;
  }

  // Restore note
  if (cartData.note) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: cartData.note }),
    });
    cartModified = true;
  }

  localStorage.setItem("customerCartChecked", true);

  // Only refresh cart drawer/UI if something changed
  if (cartModified) {
    try {
      const cart = await fetch("/cart.js").then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      });

      const [sections, updatedCart] = await Promise.all([
        fetch(getSectionsUrl()).then((res) => {
          if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
          return res.json();
        }),
        Promise.resolve(cart),
      ]);

      updateCartCount(updatedCart.item_count);

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(
          {
            items: updatedCart.items,
            sections,
            total_price: updatedCart.total_price,
          },
          false,
        );

        // If cart-items section exists in DOM, refresh it
        let mainCartItems = document.getElementById("main-cart-items");
        if (mainCartItems) {
          fetch(`${routes.cart_url}?section_id=main-cart-items`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html",
              );
              const targetElement = document.querySelector("cart-items");
              const sourceElement = html.querySelector("cart-items");

              const sourceQty = html?.querySelector(".js-contents");
              const currentInBag = mainCartItems.querySelector(".js-contents");
              if (currentInBag && sourceQty) {
                currentInBag.innerHTML = sourceQty.innerHTML;
              }

              const sourceSummary = html?.querySelector(".cart-main-box2");
              const currentSummary = mainCartItems.querySelector(".cart-main-box2");
              if (currentSummary && sourceSummary) {
                currentSummary.innerHTML = sourceSummary.innerHTML;
              }

              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
              if (window.reinitializeCartScripts)
                window.reinitializeCartScripts();
            })
            .catch((e) => {
              console.error(e);
            });
        }

        await updateCustomerCartMetafield();
      } else {
        console.error("cart-drawer element or renderContents method not found");
      }
    } catch (err) {
      console.error("❌ Failed to refresh cart:", err);
    }
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const isCartPage =
    window.location.pathname === "/cart" ||
    window.location.pathname.endsWith("/cart");
  if (!isCartPage) {
    restoreCartFromCustomerMetafield();
  }
});
